var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBootstrap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 122.88 122.88",
    style: {
      enableBackground: "new 0 0 122.88 122.88"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{fill-rule:evenodd;clip-rule:evenodd;fill:#563D7C;} .st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,107.04c0,8.75,7.09,15.84,15.84,15.84h91.19c8.75,0,15.84-7.09,15.84-15.84V15.84 c0-8.75-7.09-15.84-15.84-15.84H15.84C7.09,0,0,7.09,0,15.84V107.04L0,107.04L0,107.04z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M50.96,54.35v-17.4h15.32c1.46,0,2.87,0.12,4.22,0.36c1.35,0.24,2.55,0.68,3.6,1.3 c1.04,0.63,1.88,1.49,2.5,2.61c0.63,1.11,0.94,2.54,0.94,4.27c0,3.13-0.94,5.38-2.81,6.77c-1.88,1.39-4.27,2.08-7.19,2.08H50.96 L50.96,54.35z M34.6,24.24v74.4h36.05c3.33,0,6.58-0.42,9.74-1.25c3.16-0.83,5.97-2.12,8.44-3.86c2.47-1.74,4.43-3.98,5.89-6.72 c1.46-2.74,2.19-5.99,2.19-9.74c0-4.65-1.13-8.63-3.39-11.93c-2.26-3.3-5.68-5.61-10.26-6.93c3.33-1.6,5.85-3.65,7.56-6.15 c1.7-2.5,2.55-5.63,2.55-9.38c0-3.47-0.57-6.39-1.72-8.75c-1.15-2.36-2.76-4.25-4.85-5.68c-2.08-1.42-4.58-2.45-7.5-3.07 c-2.92-0.63-6.15-0.94-9.69-0.94H34.6L34.6,24.24z M50.96,85.93V65.5h17.82c3.54,0,6.39,0.82,8.55,2.45 c2.15,1.63,3.23,4.36,3.23,8.18c0,1.95-0.33,3.54-0.99,4.79c-0.66,1.25-1.55,2.24-2.66,2.97c-1.11,0.73-2.4,1.25-3.86,1.56 c-1.46,0.31-2.99,0.47-4.59,0.47H50.96L50.96,85.93z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBootstrap);
export default __webpack_public_path__ + "static/media/icon_bootstrap.a1951bfa31b161330ed7b1786545f8ab.svg";
export { ForwardRef as ReactComponent };